import React, { useState, useEffect } from "react";
import Category from "../../../../APIController/Category";
import Product from "../../../../APIController/Product";
import Text from "../../../../Components/Text";
import { useModal } from "../../../../Components/Modal";
import ProductForm from "../Forms/ProductForm";
import CrudPage from "../../../../Components/CrudPage";

function ProductManagement() {
    //Api controller
    const { fetchCategories } = Category()
    const { fetchProductsByCategory, deleteProduct } = Product()

    /* Modal Loader */
    const { ModalView, openModal, closeModal } = useModal()

    //Object herlper
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [products, setProducts] = useState([])

    //on startup
    useEffect(() => {
        fetchCategoryData()
    }, []);

    //on category change
    useEffect(() => {
        if (selectedCategory) {
            fetchProductsById()
        }
    }, [selectedCategory]);

    //Fetch helper
    const fetchCategoryData = async () => {
        const data = await fetchCategories();
        setCategories(data)
    };

    const fetchProductsById = async () => {
        const products = await fetchProductsByCategory(selectedCategory.id)
        setProducts(products)
    }

    const handleCategoryClick = async (category) => {
        setSelectedCategory(category)
    }

    const handleDeleteClick = async (e, product) => {
        await deleteProduct(product.id)
        fetchProductsById()
    }

    const formActions = () => {
        fetchProductsById()
        closeModal()
    }

    const handleAddClick = async (e) => {
        e.preventDefault()
        openModal(<ProductForm afterAction={formActions} categoryId={selectedCategory.id} />)
    }

    const handleEditClick = async (e, product) => {
        e.preventDefault()
        openModal(<ProductForm selectedProduct={product} afterAction={formActions} categoryId={selectedCategory.id} />)
    }

    const MainView = () => (
        <>
            <CrudPage
                title={"Produkte"}
                subtitle={selectedCategory ? `Kategorie: ${selectedCategory.name}` : null}
                items={products}
                displayMethod={(product) => (
                    <>
                        <Text type="itemmain">{product.name}</Text>
                        <Text type="itemtext">{`Preis: ${product.price}`}</Text>
                    </>
                )}
                crudActions={[
                    { type: "edit", color: "black", action: handleEditClick, icon: "edit" },
                    { type: "delete", color: "red", action: handleDeleteClick, icon: "trash" },
                    selectedCategory && { type: "create", color: "bg-white", action: handleAddClick }].filter(Boolean)}
                scrollbarOptions={{
                    itemType: "Kategorien",
                    items: categories,
                    onClickAction: handleCategoryClick,
                    itemDisplayOption: (item) => item.name,
                    colorDisplayOption: (item) => item.colorCode,
                    alwaysColored: true
                }}
                allowedTarget={"productsPerCategory"}
                currentTargetValue={products.length}
            />
            <ModalView classNames="w-auto h-full" />
        </>
    )

    return (MainView())
}

export default ProductManagement